import { Shield, ShieldCheck, BadgeCheck, Crown } from "lucide-react";

const LEVELS = {
  unverified: { label: "Unverified", icon: Shield, cls: "bg-stone-100 text-stone-500 border-stone-200" },
  community_verified: { label: "Community Verified", icon: ShieldCheck, cls: "bg-brand-pink text-brand-text border-pink-200" },
  platform_verified: { label: "Platform Verified", icon: BadgeCheck, cls: "bg-brand-gold-light text-brand-gold border-yellow-200" },
  high_trust: { label: "High Trust", icon: Crown, cls: "bg-brand-gold text-white border-brand-gold" },
};

export default function TrustBadge({ level = "unverified", size = "sm" }) {
  const cfg = LEVELS[level] || LEVELS.unverified;
  const Icon = cfg.icon;
  const padding = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border font-semibold tracking-wide uppercase ${padding} ${cfg.cls}`}
      data-testid={`trust-badge-${level}`}>
      <Icon size={size === "lg" ? 14 : 12} strokeWidth={1.8} />
      {cfg.label}
    </span>
  );
}
